import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import SpecsSection from './components/SpecsSection';
import ComparisonSectionEnhanced from './components/ComparisonSectionEnhanced';
import CategoryPage from './components/CategoryPage';
import ComparisonPage from './components/ComparisonPage';
import ProductGrid from './components/ProductGrid';
import ProductGridWithComparison from './components/ProductGridWithComparison';
import BoutiquePagePure from './components/BoutiquePagePure';
import BoutiquePageWithComparison from './components/BoutiquePageWithComparison';
import ReviewsSection from './components/ReviewsSection';
import OffersSection from './components/OffersSection';
import Footer from './components/Footer';
import ProductPage from './components/ProductPage';
import SignupPage from './components/SignupPage';
import LoginPage from './components/LoginPage';
import OrderPage from './components/OrderPage';
import OrdersPageFixed from './components/OrdersPageFixed';
import OrderDetailPageFixed from './components/OrderDetailPageFixed';
import Dashboard from './components/Dashboard';
import BoutiquePage from './components/BoutiquePage';
import CheckoutPage from './components/CheckoutPage';
import Cart, { CartProvider } from './components/Cart';
import { ComparisonProvider } from './hooks/useComparison.jsx';
import ProductAdminEnhanced from './components/ProductAdminEnhanced';
import PromotionPopup from './components/PromotionPopup';
import { AuthProvider } from './hooks/useAuth.jsx';
import { ToastProvider } from './components/Toast';
import ContactPage from './components/ContactPage';
import FAQPage from './components/FAQPage';
import SAVPage from './components/SAVPage';
import ReparationsPage from './components/ReparationsPage';
import AboutPage from './components/AboutPage';
import LegalPage from './components/LegalPage';
import PrivacyPage from './components/PrivacyPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <CartProvider>
          <ComparisonProvider>
            <Routes>
              <Route path="/" element={
                <div className="App">
                  <Header />
                  <HeroSection />
                  <ProductGrid />
                  <FeaturesSection />
                  <SpecsSection />
                  <ReviewsSection />
                  <OffersSection />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/product/:id" element={
                <div className="App">
                  <Header />
                  <ProductPage />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/category/:categoryName" element={
                <div className="App">
                  <Header />
                  <CategoryPage />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/boutique" element={
                <div className="App">
                  <Header />
                  <BoutiquePage />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/order" element={
                <div className="App">
                  <Header />
                  <OrderPage />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/orders" element={
                <div className="App">
                  <Header />
                  <OrdersPageFixed />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/orders/:orderId" element={
                <div className="App">
                  <Header />
                  <OrderDetailPageFixed />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/dashboard" element={
                <>
                  <Dashboard />
                  <PromotionPopup />
                </>
              } />
              <Route path="/boutique" element={<BoutiquePagePure />} />
              <Route path="/boutique-compare" element={<BoutiquePageWithComparison />} />
              <Route path="/comparison" element={<ComparisonPage />} />
              <Route path="/checkout" element={
                <div className="App">
                  <Header />
                  <CheckoutPage />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/admin/products" element={<ProductAdminEnhanced />} />
              <Route path="/contact" element={
                <div className="App">
                  <Header />
                  <ContactPage />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/faq" element={
                <div className="App">
                  <Header />
                  <FAQPage />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/sav" element={
                <div className="App">
                  <Header />
                  <SAVPage />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/reparations" element={
                <div className="App">
                  <Header />
                  <ReparationsPage />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/about" element={
                <div className="App">
                  <Header />
                  <AboutPage />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/legal" element={
                <div className="App">
                  <Header />
                  <LegalPage />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
              <Route path="/privacy" element={
                <div className="App">
                  <Header />
                  <PrivacyPage />
                  <Footer />
                  <PromotionPopup />
                </div>
              } />
            </Routes>
            <Cart />
          </ComparisonProvider>
        </CartProvider>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
